import { createFileRoute, Navigate, redirect } from '@tanstack/react-router';
import { hasExplicitPermissionRule, useAbility } from '@features/authorization';
import { useAuth } from '@features/auth';
import { canAccessHelpdesk } from '@shared/lib';
import type { RouterContext } from '@shared/config/router-context';

export const Route = createFileRoute('/$locale/_authenticated/crm/helpdesk/settings')({
  beforeLoad: ({ context, params }) => {
    const { auth, ability } = context as RouterContext;
    if (auth.isLoading || !auth.isAuthenticated) return;
    if (
      !canAccessHelpdesk(ability) ||
      !hasExplicitPermissionRule(auth.permissions, 'read', 'AdminTools')
    ) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/$locale/unauthorized', params: { locale: params.locale } });
    }
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/$locale/admin/settings/helpdesk',
      params: { locale: params.locale },
      replace: true,
    });
  },
  component: LegacyHelpdeskSettingsRedirect,
});

function LegacyHelpdeskSettingsRedirect() {
  const { locale } = Route.useParams();
  const auth = useAuth();
  const ability = useAbility();
  if (auth.isLoading || !auth.isAuthenticated) return null;
  if (
    !canAccessHelpdesk(ability) ||
    !hasExplicitPermissionRule(auth.permissions, 'read', 'AdminTools')
  ) {
    return <Navigate to="/$locale/unauthorized" params={{ locale }} replace />;
  }
  return <Navigate to="/$locale/admin/settings/helpdesk" params={{ locale }} replace />;
}
